// src/pages/Home/index.tsx
import {
  Container,
  Image,
  LeftContainer,
  RightContainer,
  SubTitle,
  Title,
} from "./styles";
import { Link } from "react-router-dom";
import Button from "../../components/ui/Button";
import Icon from "../../components/ui/Icon";

export default function Home() {
  return (
    <Container>
      <LeftContainer>
        <Title>OnChef</Title>
        <SubTitle>Sistema para restaurante e lanchonete</SubTitle>

        <Link to="/new">
          <Button variant="primary" size="lg">
            Entre em contato
            <Icon name="chevron" size={18} color="#fff" />
          </Button>
        </Link>
      </LeftContainer>

      <RightContainer>
        <Image />
      </RightContainer>
    </Container>
  );
}
